import { IEditAreaCodePayload, IGetAreaCodeList, IAreaCodeCreate, IAreaCodeDetails, IAreaCodeListSearch } from "../../../types/master/areaCodeInterface";
import { AreaCodeActions, AreaCodeActionTypes } from "../../actionTypes/master/areaCodeActionTypes";




export const createAreaCode = (payload: IAreaCodeCreate): AreaCodeActionTypes => ({
  type: AreaCodeActions.CREATE_AREA_CODE,
  payload,
});

export const getAreaCodeList = (payload: IAreaCodeListSearch): AreaCodeActionTypes => ({
  type: AreaCodeActions.GET_AREA_CODE_LIST,
  payload,
});

export const setAreaCodeList = (areaCodeList: Array<IGetAreaCodeList>) : AreaCodeActionTypes => ({
  type: AreaCodeActions.SET_AREA_CODE_LIST,
  payload: areaCodeList
})

export const setAreaCodeListPageCount = (payload:number): AreaCodeActionTypes => ({
  type: AreaCodeActions.SET_AREA_CODE_LIST_PAGE_COUNT,
  payload
})

export const getAreaCodeDataById = (id: number): AreaCodeActionTypes => ({
  type: AreaCodeActions.GET_AREA_CODE_DATA_BY_ID,
  payload: id
})

export const setAreaCodeDataById = (payload: IAreaCodeDetails) => ({
  type: AreaCodeActions.SET_AREA_CODE_DATA_BY_ID,
  payload
})

export const editAreaCode = (payload: IEditAreaCodePayload) => ({
  type: AreaCodeActions.EDIT_AREA_CODE_DATA_BY_ID,
  payload,
});

export const deleteAreaCode = (id: number): AreaCodeActionTypes => ({
  type: AreaCodeActions.DELETE_AREA_CODE,
  payload: id,
});
